import { delay, takeEvery, take, cancel, all, fork, call, put } from 'redux-saga/effects';
import * as SagasType from '../../constants/constant_saga_types';
import * as ActionType from '../../constants/constant_action_types';
// import { ReportTypes } from '../../constants/constant_report_types';
import * as api from '../../services/report/apiReport';
import * as apiCommon from '../../services/apiCommon';
import * as SagaCommon from '../sagasCommon';
import moment from 'moment';

export default function* (app) {
  return yield all([
    fork(executeReports, app),
    fork(fetchReportById, app),
    fork(fetchAllReports, app),
    fork(exportReport, app)
  ]);
}

export function* executeReports(app) {
  const taskCollection = {};
  while (true) {
    const action = yield take(SagasType.EXECUTE_REPORT);
    const { key } = action;
    if (Boolean(taskCollection[key])) {
      yield cancel(taskCollection[key]);
    }
    taskCollection[key] = yield fork(executeReport, app, action);
  }
}
export function* fetchReportById(app) {
  yield takeEvery(SagasType.FETCH_REPORT_BY_ID, callFetchReportById, app);
}
export function* fetchAllReports(app) {
  yield takeEvery(SagasType.FETCH_REPORT_ALL, callFetchAllReports, app);
}


function* callFetchAllReports(app, action) {
  const { silent, filters } = action;
  yield SagaCommon.showProgressListTable(silent);
  yield delay(250); 
  try {
    yield showAllReportsInProgress();
    const dataParams = {
      filters,
      list_type: 'report'
    };
    const tableData = yield call(apiCommon.getDocs, app, dataParams);
    yield call(SagaCommon.doneListTable, { rows: tableData.data, total_rows: tableData.total });
  } catch (error) {
    yield SagaCommon.showErrorListTable(error);
  }
}


function* callFetchReportById(app, action) {
  const { payload } = action;
  const { id, isExecute } = payload;

  try {
    yield showReportByIdInProgress(id);
    const doc = yield call(api.fetchReportById, app, id);
    yield showReportByIdDone(id, doc);

    if (isExecute) {
      const { filters: reportFilters } = payload;
      const { id: reportId, report_type: reportType } = doc;

      yield put({
        type: SagasType.EXECUTE_REPORT,
        payload: {
          key: reportId,
          reportId,
          reportType,
          reportFilters: reportFilters || {},
        }
      });
    }
  } catch (error) {
    yield showReportByIdError(id, error);
  }
}


function* executeReport(app, action) {
  const { payload } = action;
  const { key, reportId, reportFilters, portletType, tableRows } = payload || {};

  try {
    yield showReportInProgress(key, reportId, reportFilters);
    const params = { reportId, reportFilters, portletType, tableRows };
    const results = yield call(api.executeReport, app, params);
    yield showReportResults(key, reportId, reportFilters, results);
  } catch (error) {
    yield showReportError(key, reportId, reportFilters, error);
  }
}




function* exportReport(app) {
  yield takeEvery(SagasType.EXPORT_REPORT, callExportReport, app);
}
function* callExportReport(app, action) {
  try {
    yield put({ type: SagasType.EXPORTING_REPORT });

    const { reportId, reportName } = action.payload || {};
    const res = yield call(api.exportReport, app, action.payload || {});

    if ( res ) {
      const payload = {
        data: res || '',
        download: true,
        encoding: 'charset=utf-8',
        format: 'csv',
        mimeType: 'text/csv',
        name: `${ reportName } - ${ moment().format('L') } - ${ moment().format('LT') }`
      }
      yield put({ type: ActionType.IMMEDIATE_DOWNLOAD, payload });
      yield put({ type: SagasType.DONE_EXPORT_REPORT, payload: { reportId } });
    } else {
      throw new Error('Results not found');
    }

  } catch (error) {
    yield put({ type: SagasType.ERROR_EXPORTING_REPORT, error });
  }
}





function* showReportInProgress(key, reportId, filters) {
  yield put({ type: SagasType.SHOW_REPORT_INPROGRESS, key, reportId, filters });
}

function* showReportResults(key, reportId, filters, results) {
  yield put({ type: SagasType.SHOW_REPORT_DONE, key, reportId, filters, results });
}

function* showReportError(key, reportId, filters, error) {
  yield put({ type: SagasType.SHOW_REPORT_ERROR, key, reportId, filters, error });
}

function* showAllReportsInProgress() {
  yield put({ type: SagasType.SHOW_ALL_REPORTS_INPROGRESS });
}

function* showReportByIdInProgress(id) {
  yield put({ type: SagasType.SHOW_REPORT_BY_ID_INPROGRESS, id });
}

function* showReportByIdDone(id, doc) {
  yield put({ type: SagasType.SHOW_REPORT_BY_ID_DONE, id, doc });
}

function* showReportByIdError(id, error) {
  yield put({ type: SagasType.SHOW_REPORT_BY_ID_ERROR, id, error });
}
